import styles from './Footer.module.css';

function Footer() {
  const getTodaysDate = () => {
    const date = new Date();

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };

  const getCurrentYear = () => {
    const date = new Date();
    return date.getFullYear();
  };

  return (
    <footer>
      <div className={styles.usage_container}>
        <p className={styles.emphasis}>FOR REGULATOR USE ONLY</p>
        <p className={styles.caution}>
          CAUTION: THE INFORMATION CONTAINED ON THIS PAGE IS UNAUDITED AND NOT A COMPLETE FINANCIAL
          ANALYSIS NOR IS IT AN EXPRESSION OF OPINION ON ANY INSURER. THIS PAGE MAY CONTAIN
          INADVERTENT ERRORS AND/OR ROUNDING DIFFERENCES.
        </p>
      </div>
      <div className={styles.copyright_container}>
        <p className={styles.copyright}>
          © {getCurrentYear()} National Association of Insurance Commissioners. All rights
          reserved.
        </p>
        <p className={styles.date}>{getTodaysDate()}</p>
      </div>
    </footer>
  );
}

export default Footer;
